import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Platform } from '@ionic/angular';
import { MaintenanceTask } from '../maintenance/MaintenanceTask.model';
import { MaintenanceService } from '../maintenance.service';

@Component({
    selector: 'app-overdue-maintenance-list',
    templateUrl: './overdue-maintenance-list.component.html',
    styleUrls: ['./overdue-maintenance-list.component.scss'],
    standalone: false
})
export class OverdueMaintenanceListComponent implements OnChanges {

    static readonly NUMBER_OF_OVERDUE_MAINTENANCETASKS_TO_SHOW: number = 5;

    @Input() public maintenanceTasks: MaintenanceTask[] = null;
    @Input() public shouldRefresh = false;
    @Output() clicked = new EventEmitter<any>();

    public numberOfMaintenanceTasksToShow = OverdueMaintenanceListComponent.NUMBER_OF_OVERDUE_MAINTENANCETASKS_TO_SHOW;

    public isLoading = false;
    protected readonly Math = Math;
    private maintenanceService: MaintenanceService = inject(MaintenanceService);
    private platform: Platform = inject(Platform);

    public get isDesktop(): boolean {
        return this.platform.is('desktop');
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes.shouldRefresh &&            changes.shouldRefresh.previousValue === false &&            changes.shouldRefresh.currentValue === true) {
            await this.loadMaintenanceTasks();
        }
    }

    public emitClick() {
        this.clicked.emit();
    }

    public async refresh() {
        try {
            this.isLoading = true;
            await this.loadMaintenanceTasks();
        } catch (e) {
            console.warn(e);
        } finally {
            this.shouldRefresh = false;
            this.isLoading = false;
        }
    }

    private async loadMaintenanceTasks() {
        // console.log('APP [OverdueMaintenanceListComponent] loadMaintenanceTasks() - invoked');
        this.isLoading = true;
        try {
            if (this.isDesktop) {

                this.maintenanceTasks =                    await this.maintenanceService.getAllMaintenanceTasks(100);

            } else {
                this.maintenanceTasks =                    await this.maintenanceService.getAllMaintenanceTasks(OverdueMaintenanceListComponent.NUMBER_OF_OVERDUE_MAINTENANCETASKS_TO_SHOW);

            }

            // this.maintenanceTasks = this.maintenanceTasks.slice(
            //   0,
            //   OverdueMaintenanceListComponent.NUMBER_OF_OVERDUE_MAINTENANCETASKS_TO_SHOW
            // );
        } catch (e) {
            console.warn(e);
        } finally {
            this.isLoading = false;
        }
    }

}
